import React from 'react';
// @ts-ignore
import {
	useLazyMonitoringCentreCasesQuery,
	useLazyNurseCasesQuery,
	useTermItemsQuery,
} from '../../../../graphql/graphql';
import useFlatData from '../../../Base/Hooks/useFlatData';
import { useAppContext } from '../../../../Services/AppContext';
import useCases from '../../../Case/Hooks/useCases';
import MonitoringCenterAllRequestsFilter from './MonitoringCenterAllRequestsFilter';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import OverlayLoading from '../../../../Components/OverlayLoading';

const MonitoringCenterAllRequests: React.FC = () => {
	// @ts-ignore
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyMonitoringCentreCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
		40,
	);
	const {
		flatData,
		hasMoreData,
		loadData,
		setFilter,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getWorkplaceCases,
		{
			data: data?.monitoringCentreCases?.data,
			totalPages: data?.monitoringCentreCases?.meta?.totalPages,
			page: data?.monitoringCentreCases?.meta?.page,
		},
		page,
		setPage,
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<MonitoringCenterAllRequestsFilter onFilter={setFilter} />
			<MonitoringCenterList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				isFlatDataLoading={isFlatDataLoading}
			/>
		</div>
	);
};

export default MonitoringCenterAllRequests;
